
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^([78]04|187|347|630)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
